module.exports = __webpack_public_path__ + "img/mobi-ic.e149286a.svg";